import { initFederation } from '@softarc/native-federation-orchestrator';
import { useShimImportMap } from '@softarc/native-federation-orchestrator/options';
import { environment } from './environments/environment';
import { getExternalRedirect, transformRoute } from './app/core/route-transform';

const isProductionRoute = !window.location.pathname.startsWith('/ui-shell');
const isLocal = window.location.hostname === 'localhost';
const isDev = window.location.hostname.includes('clouddqtext');
const isQa = window.location.hostname === 'developerit.capitalone.com';

if (!isProductionRoute && !isLocal && !isDev && !isQa) {
  window.location.replace('/');
}

if (isProductionRoute && !isLocal) {
  const currentPath = window.location.pathname;
  const externalRedirect = getExternalRedirect(currentPath);

  if (externalRedirect) {
    window.location.replace(externalRedirect);
  } else {
    const transformedPath = transformRoute(currentPath);
    if (transformedPath !== currentPath) {
      const newUrl = transformedPath + window.location.search + window.location.hash;
      window.history.replaceState(null, '', newUrl);
    }
  }
}

const federation = initFederation(environment.federationManifest, {
  // shimMode delegates import map resolution to es-module-shims, required for
  // production asset paths under /ui-shell/.

  ...useShimImportMap({ shimMode: true }),
  hostRemoteEntry: environment.hostRemoteEntry,
});

federation
  .then(({ loadRemoteModule }) => import('./bootstrap').then(m => m.bootstrap(loadRemoteModule)))
  .catch((err: unknown) => console.error('Federation initialization error:', err));
